import { BsGithub } from "react-icons/bs";
import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router";

import snowFallLogo from "@/ui/common/assets/SnowFall-logo-w.png";

export const Footer = () => {
  return (
    <footer className="snowfall-footer">
      <div className="snowfall-footer-grid">
        <div className="snowfall-footer-brand">
          <img src={snowFallLogo} alt="Snow Fall" className="h-8 w-auto" />
          <p>
            A unified staking experience for Bitcoin and BABY, powered by
            Babylon and integrated by Snow Fall.
          </p>
          <span className="snowfall-footer-badge">Non-custodial staking</span>
        </div>

        <div className="snowfall-footer-column">
          <p className="snowfall-footer-title">Platform</p>
          <Link to="/btc">BTC Staking</Link>
          <Link to="/baby">BABY Staking</Link>
          <Link to="/rewards">Rewards</Link>
        </div>

        <div className="snowfall-footer-column">
          <p className="snowfall-footer-title">Snow Fall</p>
          <a href="https://www.snow-fall.io/" target="_blank" rel="noreferrer">
            Official Website <FiArrowUpRight aria-hidden="true" />
          </a>
          <a
            href="https://stake.snow-fall.io/"
            target="_blank"
            rel="noreferrer"
          >
            Staking Dashboard <FiArrowUpRight aria-hidden="true" />
          </a>
          <a
            href="https://dashboard.snow-fall.io/"
            target="_blank"
            rel="noreferrer"
          >
            Hosting Dashboard <FiArrowUpRight aria-hidden="true" />
          </a>
        </div>

        <div className="snowfall-footer-column">
          <p className="snowfall-footer-title">Resources</p>
          <a
            href="https://www.glov-solutions.com/"
            target="_blank"
            rel="noreferrer"
          >
            GLOV Solutions <FiArrowUpRight aria-hidden="true" />
          </a>
          <a
            href="https://docs.babylonlabs.io/"
            target="_blank"
            rel="noreferrer"
          >
            Babylon Docs <FiArrowUpRight aria-hidden="true" />
          </a>
          <a
            href="https://github.com/Snow-fall-io"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub aria-hidden="true" /> GitHub
          </a>
        </div>
      </div>

      <div className="snowfall-footer-bottom">
        <span>
          © {new Date().getFullYear()} Snow Fall. All rights reserved.
        </span>
        <span>Built for the Babylon ecosystem.</span>
      </div>
    </footer>
  );
};
